module.exports = __webpack_public_path__ + "static/media/information.db17ccc9.svg";